import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight, AiOutlineDownload } from "react-icons/ai";
import { SiUpwork } from "react-icons/si";
import { UPWORK_PROFILE } from "../../constants/links";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  }),
};

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <motion.h1
                className="heading"
                custom={0}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
              >
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </motion.h1>

              <motion.h1
                className="heading-name"
                custom={1}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
              >
                I'M <strong className="main-name">AFTAB ALI</strong>
              </motion.h1>

              <motion.a
                href={UPWORK_PROFILE}
                target="_blank"
                rel="noopener noreferrer"
                className="upwork-badge"
                custom={1.5}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
              >
                <span className="upwork-badge-dot" />
                <SiUpwork />
                Available for hire on Upwork
              </motion.a>

              <motion.div
                className="typewriter-wrapper"
                custom={2}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
              >
                <Type />
              </motion.div>

              <motion.div
                className="hero-cta-group"
                custom={3}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
              >
                <Link to="/project" className="btn-hero-primary">
                  View My Work <AiOutlineArrowRight />
                </Link>
                <Link to="/resume" className="btn-hero-secondary">
                  <AiOutlineDownload /> Download CV
                </Link>
                <a
                  href={UPWORK_PROFILE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-hero-upwork"
                >
                  <SiUpwork /> Hire on Upwork
                </a>
              </motion.div>
            </Col>

            <Col md={5} className="hero-image-col">
              <motion.div
                className="hero-image-wrapper"
                initial={{ opacity: 0, scale: 0.85, x: 40 }}
                animate={{ opacity: 1, scale: 1, x: 0 }}
                transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              >
                <motion.img
                  src={homeLogo}
                  alt="home pic"
                  className="hero-image img-fluid"
                  animate={{ y: [0, -12, 0] }}
                  transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
